export const CONTACT_TYPING = 'chat/CONTACT_TYPING'
export const CONTACT_STOP_TYPING = 'chat/CONTACT_STOP_TYPING'
export const FETCH_CONVERSATION_ERROR = 'chat/FETCH_CONVERSATION_ERROR'
export const FETCH_CONVERSATION_REQUEST = 'chat/FETCH_CONVERSATION_REQUEST'
export const FETCH_CONVERSATION_SUCCESS = 'chat/FETCH_CONVERSATION_SUCCESS'
export const MESSAGE_DELIVERED = 'chat/MESSAGE_DELIVERED'
export const MESSAGE_READ = 'chat/MESSAGE_READ'
export const NEW_MESSAGE_RECEIVED = 'chat/NEW_MESSAGE_RECEIVED'
export const SEND_MESSAGE_ERROR = 'chat/SEND_MESSAGE_ERROR'
export const SEND_MESSAGE_REQUEST = 'chat/SEND_MESSAGE_REQUEST'
